import { Pipe } from '@angular/core';

@Pipe({
    name: 'toDate',
    standalone: true,
})
export class ToDatePipe {
    private readonly UI_DATE_FORMAT = 'MMM d, y';

    public transform(value: Date | string | null | undefined): string {
        if (!value) {
            return '';
        }

        return new Date(value).toLocaleDateString(undefined, {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
        });
    }
}
